import React, {useState} from 'react';
import {Card, Col, Row} from "react-bootstrap";
import {FaArrowRightFromBracket, FaRegEye} from "react-icons/fa6";
import {
    FaBook,
    FaBookOpen,
    FaClipboardCheck,
    FaCoins,
    FaDollarSign,
    FaGlobe,
    FaSass,
    FaSearch,
    FaTasks
} from "react-icons/fa";
import "animate.css";
import InfoAssUnderBookS1 from "../modals/book/InfoAssUnderBookS1"; // Подключаем анимации (если еще не подключено)

// Функция для форматирования даты (месяц и день)


const AssignUnderBookS1 = ({
    assign,
    updateAssignments,
    isBookOnTopActive = false,
    bookOnTopLabel = "Book on top",
    activeAssignmentOnTopId = null,
}) => {

    const  [infoS1Visible, setinfoS1Visible] = useState(false);

    const date = new Date(assign.start_rev_date * 60 * 1000);
    const readdate = new Date(assign.start_rev_date * 60 * 1000);
// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const rmonth = months[readdate.getMonth()];
    const rday = readdate.getDate();
    const ryear = readdate.getFullYear();
    const rhours = readdate.getHours();
    const rminutes = readdate.getMinutes();

    // ✅ Вычисляем, сколько времени прошло с момента начала чтения
    const now = new Date();
    const elapsedTime = now - date;
    const elapsedMinutes = Math.floor(elapsedTime / (1000 * 60));
    const elapsedHours = Math.floor(elapsedMinutes / 60);
    const elapsedDays = Math.floor(elapsedHours / 24);

    const remainingHours = elapsedHours % 24;
    const remainingMinutes = elapsedMinutes % 60;

// Форматируем вывод (часы и минуты с ведущим нулем, если нужно)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const rformattedMinutes = rminutes < 10 ? `0${rminutes}` : rminutes;
    const rformattedHours = rhours < 10 ? `0${rhours}` : rhours;
    const isMobile = window.innerWidth <= 768; //
    const alwaysOnTopUntilMs = Number(assign?.always_on_top_until || 0);
    const isAlwaysOnTopActive = Number.isFinite(alwaysOnTopUntilMs) && alwaysOnTopUntilMs > Date.now();
    const isPausedBySiblingOnTop =
        !isBookOnTopActive &&
        !isAlwaysOnTopActive &&
        activeAssignmentOnTopId &&
        Number(activeAssignmentOnTopId) !== Number(assign?.id);
    const topBadge = isBookOnTopActive
        ? { label: bookOnTopLabel, className: "bg-success" }
        : isAlwaysOnTopActive
            ? { label: "On top", className: "bg-success" }
            : isPausedBySiblingOnTop
                ? { label: "Paused", className: "bg-secondary" }
                : null;

    return (
        <>
            <Card
                className="mt-0 p-0 mx-auto mb-1"
                style={{
                    borderRadius: '6px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer',
                    height: '118px',
                    width: isMobile ? '260px' : '230px',
                }}
                onClick={() => setinfoS1Visible(true)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <Card.Body className="d-flex flex-column position-relative py-2 px-3">
                    {topBadge && (
                        <span
                            className={`badge ${topBadge.className} text-uppercase position-absolute`}
                            style={{
                                top: '6px',
                                right: '8px',
                                borderRadius: '4px',
                                padding: '3px 6px',
                                fontSize: '0.62rem',
                                fontWeight: 'bold',
                                lineHeight: '1',
                                whiteSpace: 'nowrap',
                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.12)',
                                zIndex: 2,
                            }}
                            title={topBadge.label === "Paused"
                                ? "Not shown in library rotation while another assignment from this book is on top."
                                : undefined}
                        >
                            {topBadge.label}
                        </span>
                    )}
                    {/* Условный рендеринг для статуса */}
                    {assign.assignment_status === 'NEW' || assign?.assignment_status === 'SUSPENDED' ? (
                        <>
                            <div
                                className="fw-semibold mb-1 mt-0 text-muted"
                                style={{
                                    display: '-webkit-box',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    WebkitLineClamp: 1, // Ограничение до 1 строк
                                }}
                            >
                                <FaSearch className="me-1 fa-shake text-success" /> {/* ✅ Анимированная иконка */}
                                Finding participant...
                                                        </div>
                            <div className="d-flex flex-wrap gap-1">

                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaBookOpen className="me-2" />
                                    Start: <b>{`${rmonth}-${rday}-${ryear}`}</b> <b>{`${rformattedHours}:${rformattedMinutes}`}</b>

                                </p>


                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaBook className="me-1" /> {/* ✅ Улучшенная иконка */}
                                    Type:{" "}<b>
                                    {(() => {
                                        switch (assign.assTypeId) {
                                            case 1: return "Universal";
                                            case 2: return "Kindle Unlimited";
                                            case 3: return "Verified Purchase";
                                            case 4: return "Verified + Img";
                                            case 5: return "VP Search&Buy";
                                            case 6: return "VP Search&Buy + Img";
                                            case 7: return "Universal for Audio";
                                            case 8: return "Audible Promo Code";
                                            case 9: return "Verified Kindle Unlimited";
                                            case 10: return "PaperBack BuyOut";
                                            case 11: return "PB Search&BuyOut";
                                            case 12: return "PB Verified Pur. + Img";
                                            case 13: return "PB Verified + Video";
                                            case 14: return "HC BuyOut";
                                            case 15: return "HC Search&BuyOut";
                                            case 16: return "HC Verified Pur. + Img";
                                            case 17: return "HC Verified + Video";
                                            case 18: return "PB Verified Purchase";
                                            case 19: return "PB VP Search&Buy";
                                            case 20: return "HC Verified Purchase";
                                            case 21: return "HC VP Search&Buy";
                                            case 22: return "Product BuyOut";
                                            case 23: return "Prod. Search&BuyOut";
                                            case 24: return "Prod. Verified Pur.";
                                            case 25: return "Prod. Verified + Img";
                                            case 26: return "Prod. Verified + Vid";
                                            case 27: return "Prod. VP Search&Buy";
                                            case 28: return "Make Helpful Internal";
                                            case 29: return "Write Report Internal";
                                            case 30: return "Make Helpful External";
                                            case 31: return "Write Report External";
                                            case 32: return "Set Stars Rating";
                                            default:
                                                return "Unknown Type"; // ✅ Защита от неверных значений
                                        }
                                    })()}</b>
                                </p>

                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaCoins className="me-2" />
                                    Cost: <b>{assign.assignment_price_publisher || 'Unknown'}</b> Virt /
                                    <b className="text-danger">
                                        {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assign?.assTypeId) ? (
                                            assign?.assignment_price_publisher
                                                ? ` $${assign.book_cost_compensation}`
                                                : "N/A"
                                        ) : (
                                            (() => {
                                                let priceLabel;
                                                switch (assign?.booksPriceId) {
                                                    case 1: priceLabel = " Free"; break;
                                                    case 2: priceLabel = " $0.99"; break;
                                                    case 3: priceLabel = " $1.99"; break;
                                                    case 4: priceLabel = " $2.99"; break;
                                                    case 5: priceLabel = " $3.99"; break;
                                                    case 6: priceLabel = " $4.99"; break;
                                                    case 7: priceLabel = " $5.99"; break;
                                                    case 8: priceLabel = " $6.99"; break;
                                                    case 9: priceLabel = " $7.99"; break;
                                                    case 10: priceLabel = " $8.99"; break;
                                                    case 11: priceLabel = " $9.99"; break;
                                                    default: priceLabel = " Unknown Type";
                                                }

                                                // Добавляем " Promo" при нужных условиях
                                                if (assign?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assign?.assTypeId)) {
                                                    priceLabel += " Promo";
                                                }

                                                return priceLabel;
                                            })()
                                        )}




                                    </b>

                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaRegEye className="me-2" />
                                    {elapsedDays}D {remainingHours}H: <strong>{assign?.views}</strong> / <strong>{assign?.clicks}</strong> /
                                    <b>
                                        {(() => {
                                            switch (assign.assignment_prefer_country) {
                                                case "https://www.amazon.com":
                                                    return " US";
                                                case "https://www.amazon.ca":
                                                    return " CA";
                                                case "https://www.amazon.com.au":
                                                    return " AU";
                                                case "https://www.amazon.co.uk":
                                                    return " UK";
                                                case "https://www.amazon.de":
                                                    return " DE";
                                                case "https://www.amazon.fr":
                                                    return " FR";
                                                case "https://www.amazon.it":
                                                    return " IT";
                                                case "https://www.amazon.es":
                                                    return " ES";
                                                case "https://www.amazon.in":
                                                    return " IN";
                                                case "https://www.amazon.co.jp":
                                                    return " JP";
                                                case "https://www.amazon.com.br":
                                                    return " BR";
                                                case "https://www.amazon.nl":
                                                    return " NL";
                                                case "https://www.amazon.com.mx":
                                                    return " MX";
                                                case "https://www.amazon.sg":
                                                    return " SG";
                                                case "https://www.amazon.cn":
                                                    return " CH";
                                                default:
                                                    return " All";
                                            }
                                        })()}</b> {assign?.rating_of_reviewer > 20 && (
                                    <span className="ms-0 fw-semibold text-success">
                                        / Q-{assign.rating_of_reviewer}%
                                     </span>
                                )}&nbsp;
                                    {assign.message_to_publisher && !isAlwaysOnTopActive ? <b className="attention-message pulse">!!!</b> : ""}

                                </p>

                            </div>



                        </>
                    ) : ('No new assignments')}

                    {assign?.assignment_status === 'SUSPENDED' ? (
                        <>
                            <span className="badge bg-danger text-uppercase position-absolute"
                                  style={{
                                      bottom: '92%', left: '50%',
                                      transform: 'translateX(-50%)',
                                      backgroundColor: 'yellowgreen',
                                      borderRadius: '4px', // Делаем скругленные углы
                                      padding: '3px 6px', // Отступы по бокам для адаптации ширины
                                      height: 'auto', // Автоматическая высота
                                      display: 'inline-flex', // Гибкий контейнер, но не растягивается
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '0.65rem',
                                      fontWeight: 'bold',
                                      color: 'white',
                                      whiteSpace: 'nowrap', // Не дает тексту переноситься
                                      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                  }}>
                     Suspended


                             </span>
                        </>
                    ) : ('')}

                    {assign.freePromoStatus ? (
                        <>
                           <span  className={`badge text-uppercase position-absolute ${
                               assign.freePromoStatus === 'ACTIVE'
                                   ? 'bg-success'
                                   : assign.freePromoStatus === 'PLANNED'
                                       ? 'bg-warning text-dark'
                                       : assign.freePromoStatus === 'EXPIRED'
                                           ? 'bg-danger'
                                           : 'd-none' // скрыть, если статус не задан
                           }`}
                                 style={{
                                     bottom: '5%', right: '0%',
                                     transform: 'translateX(-12%)',
                                     backgroundColor: 'green',
                                     borderRadius: '4px', // Делаем скругленные углы
                                     padding: '3px 6px', // Отступы по бокам для адаптации ширины
                                     height: 'auto', // Автоматическая высота
                                     display: 'inline-flex', // Гибкий контейнер, но не растягивается
                                     justifyContent: 'center',
                                     alignItems: 'center',
                                     fontSize: '0.65rem',
                                     fontWeight: 'bold',
                                     color: 'white',
                                     whiteSpace: 'nowrap', // Не дает тексту переноситься
                                     boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                 }}>

                     {assign.freePromoStatus}


                             </span>
                        </>
                    ) : ('')}


                </Card.Body>
            </Card>
            <InfoAssUnderBookS1
                show={infoS1Visible}
                handleClose={() => setinfoS1Visible(false)}
                assignment={assign}
                isBookOnTopActive={isBookOnTopActive}
                bookOnTopLabel={bookOnTopLabel}
                isPausedBySiblingOnTop={isPausedBySiblingOnTop}
                activeAssignmentOnTopId={activeAssignmentOnTopId}
                updateAssignments={updateAssignments} // 🔥 Передаем коллбэк для обновления списка
            />
        </>

    );
};

export default AssignUnderBookS1;
